import {
	Box,
	Button,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
	TextField,
	Grid,
} from '@mui/material'
import {
	GridColDef,
	GridRowSelectionModel,
	useGridApiRef,
} from '@mui/x-data-grid-premium'
import {
	GridContainer,
	PageContainer,
	PageTop,
	SearchContainer,
	StyledDataGrid,
} from 'components/ApplicationStyles'
import PagePosition from 'components/PagePosition'
import { useEffect, useState } from 'react'
import { DatePicker } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'
import { confirmAlert } from '../../../util/util'
import { koKR } from '@mui/x-data-grid-premium/locales'

const Call = () => {
	const apiRef = useGridApiRef()
	const [rowSelectionModel, setRowSelectionModel] =
		useState<GridRowSelectionModel>({ type: 'include', ids: new Set() })

	const [disabledAdd] = useState(true)
	const [disabledDel] = useState(true)
	const [disabledSave] = useState(true)
	const [disabledSearch] = useState(true)
	const [disabledReset] = useState(true)
	const [disabledExcelDownload] = useState(false)
	const [hideAdd] = useState(true)
	const [hideDel] = useState(true)
	const [hideSave] = useState(true)
	const [hideSearch] = useState(true)
	const [hideReset] = useState(true)
	const [hideExcelDownload] = useState(false)
	const [loading, setLoading] = useState(false)

	// 추가
	const actionAdd = () => {}

	// 삭제
	const actionDel = () => {}

	// 저장
	const actionSave = () => {}

	// 검색
	const actionSearch = () => {}

	// 초기화
	const actionReset = () => {}

	// 키보드 엔터키 처리
	const onKeyUp = (e: React.KeyboardEvent<HTMLFormElement>) => {
		if (e.code === 'Enter') {
			actionSearch()
		}
	}
	return (
		<PageContainer>
			<PageTop>
				<PagePosition
					actionAdd={actionAdd}
					actionDel={actionDel}
					actionSave={actionSave}
					actionSearch={actionSearch}
					actionReset={actionReset}
					actionExcelDownload={() => {}}
					disabledAdd={disabledAdd}
					disabledDel={disabledDel}
					disabledSave={disabledSave}
					disabledSearch={disabledSearch}
					disabledReset={disabledReset}
					disabledExcelDownload={disabledExcelDownload}
					hideAdd={hideAdd}
					hideDel={hideDel}
					hideSave={hideSave}
					hideSearch={hideSearch}
					hideReset={hideReset}
					hideExcelDownload={hideExcelDownload}
				/>
				<SearchContainer onKeyUp={onKeyUp}>
					<Grid
						container
						spacing={2}
					>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
							/>
						</Grid>
						<Grid size={4}>
							<TextField
								label="라벨"
								variant="outlined"
								fullWidth
							/>
						</Grid>
					</Grid>
				</SearchContainer>
			</PageTop>
			<GridContainer>
				<StyledDataGrid
					apiRef={apiRef}
					columns={[]}
					rows={[]}
					showToolbar
					loading={loading}
					localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
				/>
			</GridContainer>
		</PageContainer>
	)
}

export default Call
